module.exports = __webpack_public_path__ + "static/media/rocket.8eba142e.jpg";